import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { DeploymentService } from "../../../../core/services/deployment.service";
import { GiteaService } from "../../../../core/services/gitea.service";
import {
  GiteaRepository,
  GiteaRepositoryDetail,
} from "../../../../core/models/gitea";
import { filter, Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-repo-advance-view",
  templateUrl: "./repo-advance-view.component.html",
  styleUrl: "./repo-advance-view.component.scss",
})
export class RepoAdvanceViewComponent implements OnInit {
  selectedRepository: GiteaRepository = this.giteaService.activeRepo;
  currentActiveIndex: number = 0;
  repoDetails: GiteaRepositoryDetail | null = null; // Use the proper Gitea interface
  isLoading: boolean = false;
  error: string | null = null;
  destroy$ = new Subject<void>();
  // Filter properties
  prStateFilter: string = "all";
  filteredPullRequests: any[] = [];

  @Output() closeModal = new EventEmitter<void>();

  constructor(private giteaService: GiteaService) {}

  ngOnInit(): void {
    this.loadRepoDetails(
      this.selectedRepository.owner.username,
      this.selectedRepository.name
    );
  }

  refreshComponent(): void {
    if (this.repoDetails?.basicInfo) {
      this.loadRepoDetails(
        this.repoDetails.basicInfo.owner.username,
        this.repoDetails.basicInfo.name
      );
    }
  }

  close(): void {
    this.giteaService.updateSelectedRepo(null);
    this.closeModal.emit();
  }

  focusOnTab(index: number): void {
    this.currentActiveIndex = index;
  }

  private loadRepoDetails(owner: string, repoName: string): void {
    this.isLoading = true;
    this.error = null;
    this.giteaService.SelectedRepo.pipe(
      takeUntil(this.destroy$),
      filter((x) => x != null)
    ).subscribe((repo) => {
      this.selectedRepository = this.giteaService.activeRepo;
      this.getGiteaRepoDetails(
        this.selectedRepository.owner.username,
        this.selectedRepository.name
      );
    });
  }

  getGiteaRepoDetails(owner: string, repoName: string): void {
    this.giteaService.getRepositoryDetail(owner, repoName).subscribe({
      next: (data: GiteaRepositoryDetail) => {
        this.repoDetails = data;
        this.applyPrFilter();
        this.isLoading = false;
      },
      error: (error) => {
        console.error("Error fetching repository details:", error);
        this.error = "Failed to load repository details";
        this.isLoading = false;
      },
    });
  }

  // Filter methods
  onPrFilterChange(filterValue: string): void {
    this.prStateFilter = filterValue;
    this.applyPrFilter();
  }

  applyPrFilter(): void {
    if (!this.repoDetails?.pullRequests) {
      this.filteredPullRequests = [];
      return;
    }

    if (this.prStateFilter === "all") {
      this.filteredPullRequests = [...this.repoDetails.pullRequests];
    } else {
      this.filteredPullRequests = this.repoDetails.pullRequests.filter(
        (pr) => pr.state.toLowerCase() === this.prStateFilter.toLowerCase()
      );
    }
  }

  // Helper methods for the new sections
  openCommitUrl(url: string): void {
    if (url) {
      window.open(url, "_blank");
    }
  }

  openPrUrl(url: string): void {
    if (url) {
      window.open(url, "_blank");
    }
  }

  getPrStatusIcon(state: string): string {
    switch (state?.toLowerCase()) {
      case "open":
        return "merge_type";
      case "closed":
        return "close";
      case "merged":
        return "done";
      default:
        return "help";
    }
  }

  getPrStatusClass(state: string): string {
    switch (state?.toLowerCase()) {
      case "open":
        return "text-success";
      case "closed":
        return "text-danger";
      case "merged":
        return "text-primary";
      default:
        return "text-muted";
    }
  }

  trackContributorId(index: number, contributor: any): any {
    return contributor.id || contributor.login || index;
  }
}
